import React, { useEffect, useRef, useState } from 'react';

// Component that reveals its children with a glitch effect when scrolled into view
const ScrollReveal = ({ children, delay = 0, threshold = 0.3 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isGlitching, setIsGlitching] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          // Start glitch effect first
          setIsGlitching(true);
          
          // After glitching, set to fully visible
          setTimeout(() => {
            setIsGlitching(false);
            setIsVisible(true);
          }, 700); // Glitch duration
          
          // Disconnect after animation
          observer.disconnect();
        }
      },
      { threshold }
    );
    
    const currentRef = domRef.current;
    if (currentRef) {
      setTimeout(() => {
        observer.observe(currentRef);
      }, delay);
    }
    
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [delay, threshold]);

  return (
    <div 
      ref={domRef}
      className={`scroll-reveal ${isVisible ? 'is-revealed' : ''} ${isGlitching ? 'is-glitching' : ''}`}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.7s ease, transform 0.7s ease',
      }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal; 